// extracted by mini-css-extract-plugin
export default {"tb":"tb","tb_mobile_hide_actions":"tb_mobile_hide_actions"};